/* CRACX reveal — progressive enhancement. Never hides content if JS fails. */
(function () {
  var io = null;

  function reveal(el) { el.classList.add('cx-on'); }

  function scan() {
    var els = document.querySelectorAll('.cx-rv:not([data-cx-obs])');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) {
        el.setAttribute('data-cx-obs', '1');
        reveal(el);
      });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });
    }
    Array.prototype.forEach.call(els, function (el) {
      el.setAttribute('data-cx-obs', '1');
      io.observe(el);
    });
  }

  function safety() {
    Array.prototype.forEach.call(document.querySelectorAll('.cx-rv:not(.cx-on)'), function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 1.5) reveal(el);
    });
  }

  function boot() {
    scan();
    setTimeout(safety, 700);
    setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('.cx-rv:not(.cx-on)'), function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 3) reveal(el);
      });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Hauteurs reelles du header collant -> variables CSS.
  // Evite les nombres magiques : l'annonce et la nav changent de hauteur selon la largeur.
  function headHeights() {
    var ann = document.querySelector('[id$="__cracx_announce"]');
    var nav = document.querySelector('[id$="__cracx_nav"]');
    var a = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
    var n = nav ? Math.round(nav.getBoundingClientRect().height) : 0;
    var root = document.documentElement;
    root.style.setProperty('--cx-ann-h', a + 'px');
    root.style.setProperty('--cx-nav-h', n + 'px');
    root.style.setProperty('--cx-head-h', (a + n) + 'px');
  }
  headHeights();
  window.addEventListener('resize', headHeights);
  window.addEventListener('load', headHeights);

  window.addEventListener('load', scan);
  document.addEventListener('shopify:section:load', scan);
})();
